<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;">
      <!--<a-form-item>-->
      <!--  <a-radio-group >-->
      <!--    <a-radio-button value="">-->
      <!--      ALL-->
      <!--    </a-radio-button>-->
      <!--    <a-radio-button value="facebook">-->
      <!--      <img src="static/img/facebook.png" style="width: 80px;">-->
      <!--    </a-radio-button>-->
      <!--    <a-radio-button value="google">-->
      <!--      <img src="static/img/google.png" style="width: 80px;">-->
      <!--    </a-radio-button>-->
      <!--    <a-radio-button value="tiktok">-->
      <!--      <img src="static/img/tiktok.png" style="width: 80px;">-->
      <!--    </a-radio-button>-->
      <!--  </a-radio-group>-->
      <!--</a-form-item>-->
      <a-form-item>
        <a-radio-group v-model="platform" @change="init_data" button-style="solid">
          <a-radio-button value="">
            ALL
          </a-radio-button>
          <a-radio-button value="ios">
            <a-icon type="apple" />
          </a-radio-button>
          <a-radio-button value="android">
            <a-icon type="android" />
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item>
        <a-select v-model="channel" @change="init_data" style="width: 200px" allowClear :maxTagCount="1" placeholder="请选择渠道">
          <a-select-option key="2">
            <img src="static/img/facebook.png" style="height: 20px;">
          </a-select-option>
          <a-select-option key="3">
            <img src="static/img/google.png" style="height: 20px;">
          </a-select-option>
          <a-select-option key="4">
            <img src="static/img/tiktok.png" style="height: 20px;">
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select v-model="product" style="width: 200px" allowClear
                  :maxTagCount="1" placeholder="请选择产品"
                  optionFilterProp="label" show-search
                  @change="changeProduct()">
          <a-select-option v-for="productItem in $store.getters.getAppAll"
                           :label="productItem.app_name"
                           :value="productItem.app_id"
                           :key="productItem.app_id">
            {{productItem.app_name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-input v-model="name" allowClear @pressEnter="init_data" placeholder="账户/名称">
          <a-icon slot="prefix" type="dropbox" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item style="float: right;margin: 0">
        <!--<a-button icon="sync" html-type="submit" ></a-button>-->
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" :data-source="tableData"
             style="background: #ffffff;" :loading="tableLoad" :rowKey="item=>item.advertiser_id"
             bordered :pagination="false">
      <template slot="app_id" slot-scope="text">
        <ApplicationShow :application-list="$store.getters.getAppAll" :app-id="text"></ApplicationShow>
      </template>
      <template slot="advertiser_id" slot-scope="text,recode">
        {{text}}<span v-if="recode.channel===3" style="color: #1890ff">({{recode.manage}})</span>
      </template>
      <template slot="platform" slot-scope="text">
        <a-icon style="font-size: 20px;" :type="text==='ios'?'apple':'android'"></a-icon>
      </template>
      <template slot="channel" slot-scope="text">
        <img v-if="text===2" :src="'static/img/facebook.png'" style="height: 20px;">
        <img v-if="text===3" :src="'static/img/google.png'" style="height: 20px;">
        <img v-if="text===4" :src="'static/img/tiktok.png'" style="height: 20px;">
      </template>
      <template slot="status" slot-scope="text,recode">
        <a-switch :checked="Boolean(recode.status)" @change="changeStatus($event, recode)" />
      </template>
      <template slot="footer"  slot-scope="currentPageData">
        <a-pagination
          v-model="page"
          style="text-align: right"
          show-size-changer
          :total="count"
          :page-size="page_size"
          @change="changePage"
          @showSizeChange="changePage"
        />
      </template>
    </a-table>
  </div>
</template>

<script>
import {GetAccountPage, StatusAccount} from "@/api/v1/app_api";
import ApplicationShow from "@/components/V1/ApplicationShow";

export default {
  name: "Account",
  components: {ApplicationShow},
  data(){
    return {
      platform:'',
      channel:'',
      product:'',
      name:'',
      productList:[],
      tableData:[],
      count:100,
      page:1,
      page_size:10,
      tableLoad:false,
    }
  },
  mounted() {
    this.init_data()
  },
  computed: {
    getTableColumns(){
      let _table_columns = [
        {title: '应用', dataIndex: 'app_id',scopedSlots: { customRender: 'app_id' },},
        {title: '平台', dataIndex: 'platform',scopedSlots: { customRender: 'platform' },},
        {title: '渠道', dataIndex: 'channel',scopedSlots: { customRender: 'channel' },},
        {title: '名称', dataIndex: 'name',},
        {title: '账户', dataIndex: 'advertiser_id',scopedSlots: { customRender: 'advertiser_id' }},
        {title: '状态', dataIndex: 'status',scopedSlots: { customRender: 'status' }},
      ]
      return _table_columns
    }
  },
  methods: {
    init_data(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetAccountPage({
        platform:this.platform,
        channel:this.channel,
        product:this.product,
        name:this.name,
        page:this.page,
        page_size:this.page_size
      }).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.tableData = resp.data.list
          this.count = resp.data.count
          this.page = resp.data.page
          this.page_size = resp.data.page_size
        }
      })
    },
    changePage(page,page_size){
      this.page = page
      this.page_size = page_size
      this.init_data()
    },
    changeProduct(){
      this.init_data()
    },
    changeStatus(e,recode){
      if (this.tableLoad) return
      this.tableLoad = true
      StatusAccount({advertiser_id:recode.advertiser_id}).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.$message.success(resp.msg)
          if(e){
            recode.status=1
          }else{
            recode.status=0
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/System/Application/Account.vue